import { render } from "./ModulosPermisos.vue?vue&type=template&id=d4b1a2d6&scoped=true"
import script from "./ModulosPermisos.vue?vue&type=script&lang=js"
export * from "./ModulosPermisos.vue?vue&type=script&lang=js"

import "./ModulosPermisos.vue?vue&type=style&index=0&id=d4b1a2d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4b1a2d6"]])

export default __exports__